import { defaultStore, stores } from '../../translations';

/**
 * Нормализует ссылки с учетом текущего домена и поддомена
 * Поддерживаемые домены: .ru, .ae, .kz, .qa, .sa, .by
 * @param {string} link - исходная ссылка
 * @param {string} baseUrl - базовый URL для нормализации
 * @returns {string} - нормализованная ссылка
 */
export function normalizeLink(link, baseUrl = '') {
  if (!link || typeof link !== 'string' || !baseUrl) return link;

  // Регулярка для проверки goldapple доменов
  const goldappleRegex = /^https?:\/\/(?:[^/]*\.)?goldapple\.(ru|ae|kz|qa|sa|by)/i;

  // Случай 1: Ссылка на goldapple - заменяем на текущий origin (включая поддомен)
  if (goldappleRegex.test(link)) {
    try {
      const url = new URL(link);
      const path = url.pathname + url.search + url.hash;
      return baseUrl + path;
    } catch (e) {
      return link;
    }
  }

  // Случай 2: Внутренняя ссылка (относительная)
  if (!/^https?:\/\//i.test(link)) {
    const normalizedPath = link.startsWith('/') ? link : `/${link}`;
    return baseUrl + normalizedPath;
  }

  // Случай 3: Внешняя ссылка (не goldapple) - возвращаем как есть
  return link;
}

export default normalizeLink;
